<template>
  <div v-if="!isLogin && !hasMaintenance" class="flex items-center gap-2">
    <TheButton
      v-if="!isMobile"
      :id="isCN ? 'tracking_login' : undefined"
      type="tonal"
      :title="$t('header.sign-in')"
      class="w-[132px]"
      @click="handleLogin"
    >
      <span
        v-if="isUserVerifying"
        class="flex h-6 w-full items-center justify-center"
      >
        <IconLoader class="h-4 w-4 text-black" />
      </span>
      <span v-else class="text-sm font-bold">
        {{ $t('header.sign-in') }}
      </span>
    </TheButton>
    <button
      v-else
      :id="isCN ? 'tracking_login' : undefined"
      class="flex items-center justify-center rounded-full p-3 hover:bg-gray-600_a25 active:bg-gray-600_a35"
      :title="$t('header.sign-in')"
      @click="handleLogin"
    >
      <IconLoader v-if="isUserVerifying" class="h-6 w-6" />
      <IconUser v-else class="h-6 w-6" />
    </button>
    <TheButton
      v-if="!isMobile && !isUserVerifying"
      :title="$t('header.get-started')"
      class="w-[132px]"
      @click="handleLogin"
    >
      <span class="text-sm font-bold">
        {{ $t('header.get-started') }}
      </span>
    </TheButton>
  </div>
</template>

<script setup lang="ts">
  const { isCN } = useLanguage();
  const { isMobile } = useScreen();
  const profileStore = useProfileStore();
  const { isLogin, isUserVerifying, profile } = storeToRefs(profileStore);

  const hasMaintenance = computed((): boolean => {
    /**
     * * NOTE: 目前是否有開啟維護公告
     * * 如果有開啟維護公告，則不顯示登入按鈕（未登入）與會員按鈕（已登入）
     */
    return !!profile.value.maintenanceTimePeriod;
  });

  const handleLogin = (): void => {
    if (import.meta.client && !isUserVerifying.value) {
      const callbackUrl = window.location.href;
      profileStore.HANDLE_LOGIN(callbackUrl);
    }
  };
</script>
